import { render, staticRenderFns } from "./ConversationNav.vue?vue&type=template&id=3066f786&scoped=true&"
import script from "./ConversationNav.vue?vue&type=script&lang=ts&"
export * from "./ConversationNav.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationNav.vue?vue&type=style&index=0&id=3066f786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066f786",
  null
  
)

export default component.exports